import { useStaticQueryDataChatMutuo } from "../query/useStaticQueryDataChatMutuo";
import { CLEAR_LAST_LANDING_SLUG } from "../state/actions/navigation.actions";
import Footer from "./Footer";
import MenuDesktop from "./MenuDesktop";
import ServiceBar from "./ServiceBar";
import loadable from "@loadable/component";
import classNames from "classnames";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

const ConfrontoModalMutuo = loadable(() => import("./ConfrontoModalMutuo"));
const ChatMutuo = loadable(() => import("./ChatMutuo"));

const Layout = ({ children, data, location }) => {
  const dispatch = useDispatch();
  const isHpTemplate = data?.page?.template?.hp_template || false;
  const isHpTemplateLightVersion =
    data?.page?.template?.hp_template?.versioneLight || false;
  const isFullModalRoute = /^\/(mutuo|verifica)\//.test(location?.pathname || "");
  const isFullLayout = (location?.state?.full || false) && isFullModalRoute;
  const isChatMutuoTemplate =
    data?.page?.template?.templateName === "ChatMutuo" || false;
  const isPageConfermaAppuntamenti =
    data?.page?.template?.templateName === "Conferma Appuntamenti" || false;
  const isLandingPageTemplate =
    data?.page?.template?.templateName === "Landing Page" || false;

  useEffect(() => {
    if (!isLandingPageTemplate && !isChatMutuoTemplate) {
      dispatch(CLEAR_LAST_LANDING_SLUG());
    }
  }, [isLandingPageTemplate, isChatMutuoTemplate, dispatch]);

  const { chatMutuo } = useStaticQueryDataChatMutuo();

  const totalDisableChat = chatMutuo?.disattivazioneTotaleChatMutuo;
  const disableChat = data?.page?.disattivaChat?.disattiva_chat || false;
  return (
    <>
      {!isFullLayout && !isLandingPageTemplate && (
        <MenuDesktop
          isHpTemplate={isHpTemplate}
          isChatMutuoTemplate={isChatMutuoTemplate}
          lightVersion={
            isHpTemplateLightVersion || isPageConfermaAppuntamenti || false
          }
        />
      )}
      <main
        className={classNames({
          main: !isFullLayout,
          "main-no-margin": isHpTemplate || isChatMutuoTemplate,
          "main-no-overflow chatmutuo": isChatMutuoTemplate,
        })}
      >
        {children}
      </main>
      {!isFullLayout && (
        <>
          <Footer />
          {!isPageConfermaAppuntamenti && (
            <ServiceBar
              isChatMutuoTemplate={isChatMutuoTemplate}
              isHpTemplate={isHpTemplate}
              isHpTemplateLightVersion={isHpTemplateLightVersion}
              isLandingPageTemplate={isLandingPageTemplate}
            />
          )}
          <ConfrontoModalMutuo />
          {totalDisableChat !== true &&
            !isChatMutuoTemplate &&
            !isPageConfermaAppuntamenti &&
            disableChat !== true && <ChatMutuo location={location} />}
        </>
      )}
    </>
  );
};

export default Layout;
